import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import ContactusForm from './vue/components/contactus-form/ContactusForm.vue';

const mixins = [];

initMain(mixins, {
    ContactusForm
});
header();